module.exports = __webpack_public_path__ + "static/seo_image-939e8e249cf62a835ed560f6da4200ad.jpg";